import Profile from '@/models/Profile';

const GET_PROFILE = 'get_profile';
const GET_PROFILE_REQUEST = 'get_profile_request';
const GET_PROFILE_SUCCESS = 'get_profile_success';
const GET_PROFILE_ERROR = 'get_profile_error';
const GET_PROFILE_EVALUATION = 'get_profile_evaluation';
const GET_EXPIRED_EVALUATION_PROFILE = 'get_expired_evaluation_profile';

export { GET_PROFILE, GET_PROFILE_EVALUATION };

export default {
    state: {
        id: 0,
        profile: [],
        loading: false,
        profileErrors: [],
        profileMeta: {},
        diploma: 0,
        work_process: 0,
        evaluation: 0,
        expired_evaluation: false
    },
    mutations: {
        [GET_PROFILE_REQUEST]: (state) => {
            state.profile = [];
            state.loading = true;
            state.profileErrors = [];
        },
        [GET_PROFILE_SUCCESS]: (state, { profile, meta }) => {
            state.profile = profile;
            state.loading = false;
            state.profileErrors = [];
            state.profileMeta = meta;
        },
        [GET_PROFILE_ERROR]: (state, { errors }) => {
            state.profile = [];
            state.loading = false;
            state.profileErrors = errors;
            state.profileMeta = {};
        },
        [GET_EXPIRED_EVALUATION_PROFILE]: (state, { errors }) => {
            state.profile = [];
            state.loading = false;
            state.expired_evaluation = true;
            state.profileErrors = errors;
            state.profileMeta = {};
        },
    },
    actions: {
        [GET_PROFILE]: ({ commit, state }, { id = state.id }) => {
            commit(GET_PROFILE_REQUEST);
            return new Promise((resolve, reject) => {
                Profile.document(id)
                    .then((profile) => {
                        commit(GET_PROFILE_SUCCESS, { profile });
                        resolve(profile);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_PROFILE_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
        [GET_PROFILE_EVALUATION]: ({ commit, state }, { id = state.id, diploma = state.diploma, work_process = state.work_process, evaluation = state.evaluation }) => {
            commit(GET_PROFILE_REQUEST);
            return new Promise((resolve, reject) => {
                Profile.evaluationProfile(id, diploma, work_process, evaluation)
                    .then((profile) => {
                        commit(GET_PROFILE_SUCCESS, { profile });
                        resolve(profile);
                    })
                    .catch(({ status, errors }) => {
                        if (Array.isArray(errors) && errors.length >= 1 && errors[0] === 'Expired evaluation'){
                            commit(GET_EXPIRED_EVALUATION_PROFILE, { errors });
                            reject({ status, errors });
                        }
                        commit(GET_PROFILE_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/profile.js